import React from "react";
import Returnfinal from "../Components/OrderDetails/Returnfinal";
import Breadcrumb from "../Components/Breadcrumb";
import Relatedproducts from "../Components/Productdetails/Relatedproducts";
import { useEffect } from "react";
function Returnfinalpage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Breadcrumb
        title_1="Your Account"
        title_2="Orders"
        title_3="Order Details"
      />
      <Returnfinal />
      <Relatedproducts />
    </>
  );
}

export default Returnfinalpage;
